import { Animation } from './animation.model';
import { BackgroundMedia } from './background-media.model';
import { Border } from './border.model';
import { Css } from './css.model';
import { Margin } from './margin.model';
import { Padding } from './padding.model';

export class Row {
  IsNested: boolean = false;
  FullWidth: boolean = false;
  MaxWidth?: string;
  FullHeight: boolean = false;
  // AlignmentType?: string;
  JustifyContent?: string;
  AlignItems?: string;
  MinHeight?: string;
  Masonry: boolean = false;
  MasonryType: number = 0;
  // Padding: Padding = new Padding();
  // Margin: Margin = new Margin();
  // Border: Border = new Border();
  BackgroundMedia: BackgroundMedia = new BackgroundMedia();
  Css: Css = new Css();
  Animation?: Animation;
  Styles?: string[];
}
